function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarburst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M19.44 50.16 8.22 30.72h22.5V8.13l19.44 11.31L61.44 0l11.28 19.44L92.16 8.13v22.59h22.59l-11.31 19.44 19.44 11.28-19.44 11.28 11.31 19.44H92.16v22.5l-19.44-11.22-11.28 19.44-11.28-19.44-19.44 11.22v-22.5H8.22l11.22-19.44L0 61.44l19.44-11.28z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarburst);
export default __webpack_public_path__ + "static/media/starburst.857851f544474a66a7908449d576697d.svg";
export { ForwardRef as ReactComponent };